(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaisir-featured-products"] && !Shopify.designMode) return;
  try {
    
  const featuredTracks = document.querySelectorAll('[data-plaisir-featured-scroll]');

  featuredTracks.forEach((track) => {
    const range = track.parentElement.querySelector('[data-plaisir-featured-range]');

    const syncRange = () => {
      if (!range) return;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      range.hidden = maxScroll <= 1;
      range.max = String(Math.round(maxScroll));
      range.value = String(Math.round(track.scrollLeft));
    };

    track.addEventListener('scroll', syncRange, { passive: true });
    if (range) {
      range.addEventListener('input', () => {
        track.scrollLeft = Number(range.value);
      });
    }
    window.addEventListener('resize', syncRange);
    syncRange();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaisir-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-plaisir-home-reviews]');
    if (!sections.length) return;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function starsHtml(rating) {
      let html = '';
      for (let i = 1; i <= 5; i += 1) {
        html += '<span class="plaisir-home-reviews__star' + (i <= rating ? ' is-on' : '') + '">★</span>';
      }
      return html;
    }

    function reviewText(review) {
      const body = review.body_html || review.body || '';
      if (body.replace(/<[^>]*>/g, '').trim()) {
        return body.replace(/<[^>]*>/g, '').trim();
      }
      if (review.title) return review.title;
      return '';
    }

    function fetchReviews(productId, shopDomain, perPage) {
      const endpoint =
        'https://api.judge.me/reviews/reviews_for_widget?url=' +
        encodeURIComponent(window.location.hostname) +
        '&shop_domain=' +
        encodeURIComponent(shopDomain) +
        '&platform=shopify&product_id=' +
        encodeURIComponent(productId) +
        '&per_page=' +
        encodeURIComponent(perPage);

      return fetch(endpoint)
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    function initSection(section) {
      const slidesRoot = section.querySelector('[data-plaisir-reviews-slides]');
      const dotsRoot = section.querySelector('[data-plaisir-reviews-dots]');
      const ratingNode = section.querySelector('[data-plaisir-reviews-rating]');
      const countNode = section.querySelector('[data-plaisir-reviews-count]');
      if (!slidesRoot || !dotsRoot) return;

      const shopDomain = section.getAttribute('data-shop-domain') || '';
      const perPage = Number(section.getAttribute('data-per-page') || 4);
      const productIds = (section.getAttribute('data-product-ids') || '')
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);

      let slides = Array.from(section.querySelectorAll('[data-plaisir-reviews-slide]'));
      let activeIndex = 0;
      let timer = null;
      const duration = Number(getComputedStyle(section).getPropertyValue('--plaisir-home-reviews-duration').replace('s', '')) || 6;

      function renderSlides(reviews) {
        if (!reviews.length) return;

        slidesRoot.innerHTML = reviews
          .slice(0, section.classList.contains('plaisir-home-reviews--split') ? 3 : reviews.length)
          .map(function (review, index) {
            const text = escapeHtml(reviewText(review));
            if (!text) return '';

            return (
              '<article class="plaisir-home-reviews__slide' +
              (index === 0 ? ' is-active' : '') +
              '" data-plaisir-reviews-slide>' +
              '<blockquote class="plaisir-home-reviews__quote-text"><p><span class="plaisir-home-reviews__mark" aria-hidden="true">“</span>' +
              text +
              '</p></blockquote>' +
              '<div class="plaisir-home-reviews__stars" aria-hidden="true">' +
              starsHtml(Number(review.rating || 5)) +
              '</div>' +
              '</article>'
            );
          })
          .join('');

        slides = Array.from(section.querySelectorAll('[data-plaisir-reviews-slide]'));
        activeIndex = 0;
        buildDots();
        startAutoplay();
      }

      function buildDots() {
        dotsRoot.innerHTML = slides
          .map(function (_, index) {
            return (
              '<button type="button" class="plaisir-home-reviews__dot' +
              (index === activeIndex ? ' is-active' : '') +
              '" data-plaisir-reviews-dot="' +
              index +
              '" role="tab" aria-label="Review ' +
              (index + 1) +
              '" aria-selected="' +
              (index === activeIndex ? 'true' : 'false') +
              '"></button>'
            );
          })
          .join('');

        dotsRoot.querySelectorAll('[data-plaisir-reviews-dot]').forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(Number(dot.getAttribute('data-plaisir-reviews-dot')));
          });
        });
      }

      function goTo(index) {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === activeIndex);
        });

        dotsRoot.querySelectorAll('[data-plaisir-reviews-dot]').forEach(function (dot, dotIndex) {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function startAutoplay() {
        if (timer) window.clearInterval(timer);
        if (slides.length < 2) return;

        timer = window.setInterval(function () {
          goTo(activeIndex + 1);
        }, duration * 1000);
      }

      function updateBadge(reviews, totalCount, averageRating) {
        if (ratingNode && averageRating) {
          ratingNode.textContent = averageRating.toFixed(1) + ' out of 5';
        }

        if (countNode && totalCount && !section.classList.contains('plaisir-home-reviews--split')) {
          countNode.textContent = totalCount + '+ Five Star Reviews';
        }
      }

      const splitLayout = section.classList.contains('plaisir-home-reviews--split');

      if (!splitLayout) {
        buildDots();
        startAutoplay();
      }

      if (splitLayout || !productIds.length) return;

      Promise.all(productIds.map(function (productId) {
        return fetchReviews(productId, shopDomain, perPage);
      })).then(function (responses) {
        const merged = [];
        let totalCount = 0;
        let ratingSum = 0;
        let ratingCount = 0;

        responses.forEach(function (data) {
          if (!data) return;

          if (data.number_of_reviews) {
            totalCount += Number(data.number_of_reviews);
          }

          (data.reviews || []).forEach(function (review) {
            const text = reviewText(review);
            if (!text) return;

            merged.push(review);

            if (review.rating) {
              ratingSum += Number(review.rating);
              ratingCount += 1;
            }
          });
        });

        const unique = [];
        const seen = new Set();

        merged.forEach(function (review) {
          const key = reviewText(review);
          if (seen.has(key)) return;
          seen.add(key);
          unique.push(review);
        });

        if (!unique.length) return;

        const averageRating = ratingCount ? ratingSum / ratingCount : 5;
        updateBadge(unique, totalCount || unique.length, averageRating);
        renderSlides(unique.slice(0, 12));
      });
    }

    sections.forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();
})();
